import React from 'react';
import MainLayout from '../components/layout/MainLayout';
import FeedbackComponent from '../components/feedback/FeedbackComponent.jsx';

const FeedbackPage = () => {
  return (
    <MainLayout>
      <FeedbackComponent />
    </MainLayout>
  )
}

export default FeedbackPage
